import React from 'react'
import logo from 'src/assets/images/logo.jpg'

const LogoHeader = () => {
  return (
    <div className="card">
      <div className="card-body">
        <div className="d-flex justify-content-center align-items-center">
          <img
            className="img-fluid"
            style={{ height: '70px', width: 'auto', marginRight: '10px' }}
            src={logo}
            alt="Logo"
          />
          <div className="d-flex flex-column align-items-center">
            <span className="mt-2" style={{ fontWeight: 'bold' }}>
             चिकित्सा शिक्षा और अनुसंधान विभाग हरियाणा
            </span>
            <span style={{ fontWeight: 'bold' }}>
             Department of Medical Education & Research Haryana
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LogoHeader
